import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import AxioInstance from '../../axios/AxiosConfig';
import { AuthContext } from '../../context/AuthContext';
import { AiOutlinePlusCircle } from 'react-icons/ai';

const Card = ({ name, binCard, history, cardInfo, card_name = null }) => {
    return (
        <button
            className="w-full h-20 bg-white rounded-lg flex justify-center p-4 mb-3"
            onClick={() => {
                history.push('/tarjetas/detalle', { ...cardInfo });
            }}
        >
            <div className="flex justify-between items-center w-full">
                <div className="flex items-center">
                    <div className="w-16 h-12 bg-gray-200 rounded flex items-center justify-center">
                        <img
                            src={require('../../assets/card/VISA.png')}
                            alt="Card Logo"
                            className="w-10 h-8 object-contain"
                        />
                    </div>
                    <div className="ml-5 text-left">
                        <p className="font-medium text-lg text-gray-900">
                            {'•••• •••• •••• '}{binCard.slice(-4)}
                            {/*  {card_name ? card_name : `•••• •••• •••• ${binCard.slice(-4)}`} */}
                        </p>
                        {card_name ?
                            <p className="text-base text-gray">

                                {card_name}

                            </p>
                            : null
                        }

                    </div>
                </div>
            </div>
        </button>
    );
};

const ListCards = ({ cards, history }) => {
    return (
        <div className="flex flex-col items-center w-full p-6">
            <h1 className="text-center font-bold text-2xl text-gray-900 mb-6">
                Listado de Tarjetas
            </h1>
            <div className="space-y-3 w-full">
                {cards?.map((card, i) => (
                    <Card
                        cardInfo={card}
                        key={i}
                        name={card.name}
                        binCard={card.masked_pan}
                        history={history}
                        card_name={card?.card_name}
                    />
                ))}
            </div>
        </div>
    );
};

const CardsList = (props) => {
    const { history } = props;
    console.log('🚀 ~ CardsList ~ props:', props)
    const [cards, setCards] = useState(props.cards);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { getAuthenticatedHeaders } = useContext(AuthContext);
    useEffect(() => {
        const fetchCards = async () => {
            try {
                const response = await AxioInstance.post('/api/get_card', {
                    headers: await getAuthenticatedHeaders(),
                });
                console.log("🚀 ~ fetchCards ~ response:", response)
                if (response.data?.status === 200) {
                    setError(null)
                    const cardsList = response.data?.data?.result

                    setCards(cardsList); // Asumiendo que las tarjetas están en response.data.data
                } else {
                    setError('Ups! Ha ocurrido un error al cargar las tarjetas');
                }
            } catch (e) {
                setError(e);
            } finally {
                setLoading(false);
            }
        };

        fetchCards();
    }, []);

    /* if (loading) return <p>Cargando...</p>; */
    if (error) return <p>Error al cargar las tarjetas: {error.message}</p>;

    return (
        <div className="flex flex-col min-h-screen bg-gray-100">
            <header className="p-4 flex justify-between items-center bg-white shadow">
                <button
                    onClick={() => { }}
                    className="text-gray-700 hover:text-gray-900"
                >
                    {/* <i className="text-2xl">&#8592;</i> */}
                </button>
                <button
                    onClick={() => {
                        history.push('/tarjetas/crear')
                    }}
                    className="text-gray-700 hover:text-gray-900"
                >
                    <AiOutlinePlusCircle size="2em" className="text-green-600 ml-3 cursor-pointer" on />
                </button>
            </header>
            <main className="flex-grow">
                <ListCards cards={cards} history={history} />
            </main>
        </div>
    );
};

export default CardsList;
